import { render } from "./VueCodeBlock.vue?vue&type=template&id=06c1ed61"
import script from "./VueCodeBlock.vue?vue&type=script&lang=js"
export * from "./VueCodeBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__